(function ($) {

    $( window ).on(
        'elementor/frontend/init',
        function ( event ) {
            event.target.elementorFrontend.hooks.addAction(
                'frontend/element_ready/media-carousel.default',
                function ( event ) {
                    setTimeout( function () {
                        let $element = $('.ameen_main-page-carousel .elementor-main-swiper');

                        if ( $element.length ) {
                            let swiper = $element.data( 'swiper' );

                            if ( 'undefined' !== typeof swiper ) {
                                swiper.params.centeredSlides = true;
                                swiper.params.slideToClickedSlide = true;
                                swiper.update();
                            }
                        }
                    }, 1000 )
                }
            );
        }
    );

})( jQuery );

